// extracted by mini-css-extract-plugin
export default {"Flash":"BlobLowerBanners-module__Flash--idYKd"};